import { Injectable } from '@angular/core';
import proj4 from 'proj4';
import { CadastrePoint } from '../models/cadastre.models';

@Injectable({ providedIn: 'root' })
export class GeometryService {
  constructor() {
    // Matches the Python logic:
    // Transformer.from_crs("EPSG:31259", "EPSG:4326")
    // transformer.transform(x + 750000, y - 5000000)
    //
    // EPSG:31259: Austrian cadastral / Gauss-Krueger style with false easting/northing.
    proj4.defs(
      'EPSG:31259',
      // Matches pyproj EPSG:31259 -> EPSG:4326 for Austrian MGI / GK M34.
      // The datum shift is required; without it the geometry is offset by a few meters.
      '+proj=tmerc +lat_0=0 +lon_0=16.3333333333333 +k=1 +x_0=750000 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs +type=crs'
    );
  }

  originalToWgs84(x: number, y: number): { lat: number; lon: number } {
    const [lon, lat] = proj4('EPSG:31259', 'EPSG:4326', [x + 750000, y - 5000000]);
    return { lat, lon };
  }

  distanceMeters(a: CadastrePoint, b: CadastrePoint): number {
    return Math.hypot(b.x - a.x, b.y - a.y);
  }

  polygonAreaSquareMeters(points: CadastrePoint[]): number {
    let sum = 0;
    for (let i = 0; i < points.length; i++) {
      const current = points[i];
      const next = points[(i + 1) % points.length];
      sum += current.x * next.y - next.x * current.y;
    }
    return Math.abs(sum) / 2;
  }

  pointToLatLng(point: CadastrePoint): [number, number] {
    return [point.lat, point.lon];
  }
}
